export default __webpack_public_path__ + "static/media/center.6c9d0854.png";